module.exports = __webpack_public_path__ + "static/media/success-banner.5ccd6e47.png";